/* Malesia API Error Codes */

export const API_ERROR_CODE: Record<string, number> = {
    // DATA_DOES_NOT_RESPOND_AGAINST_SCHEMA: 0,
    //
    NOT_ENOUGH_SEATS_ERROR_CODE: 1101,
    SEATS_OCCUPIED_ERROR_CODE: 1102,
};
